(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock"] && !Shopify.designMode) return;
  try {
    (function () {
  var productId = null;
  var currentVariantId = null;
  var currentVariantTitle = null;

  function init() {
    document.querySelectorAll('.bis-wrapper').forEach(function (wrapper) {
      var pid = wrapper.dataset.productId;
      productId = pid;

      var variantsEl = document.getElementById('bis-variants-' + pid);
      if (!variantsEl) return;

      var variants = JSON.parse(variantsEl.textContent);
      var popup = document.getElementById('bis-popup-' + pid);

      function updateVisibility(variantId) {
        var v = variants.find(function (x) { return String(x.id) === String(variantId); });
        if (!v) return;
        currentVariantId = v.id;
        currentVariantTitle = v.title;
        wrapper.style.display = v.available ? 'none' : '';
      }

      var form = document.querySelector('.f8pr');
      if (form) {
        var initial = form.dataset.currentVariant || form.querySelector('[data-current-variant]')?.dataset.currentVariant;
        if (initial) updateVisibility(initial);

        var observer = new MutationObserver(function () {
          var el = form.querySelector('[data-current-variant]');
          if (el) updateVisibility(el.dataset.currentVariant);
        });
        observer.observe(form, { attributes: true, subtree: true, attributeFilter: ['data-current-variant'] });
      }

      wrapper.querySelector('.bis-trigger-btn').addEventListener('click', function () {
        var name = wrapper.dataset.productTitle;
        if (currentVariantTitle && currentVariantTitle !== 'Default Title' && currentVariantTitle !== 'Standaardtitel') {
          name += ' – ' + currentVariantTitle;
        }
        popup.querySelector('.bis-product-name').textContent = name;
        popup.removeAttribute('hidden');
        popup.querySelector('.bis-email').focus();
      });

      popup.querySelector('.bis-overlay').addEventListener('click', closePopup.bind(null, popup));
      popup.querySelector('.bis-close').addEventListener('click', closePopup.bind(null, popup));

      popup.querySelector('.bis-form').addEventListener('submit', function (e) {
        e.preventDefault();
        var email = popup.querySelector('.bis-email').value.trim();
        var errorEl = popup.querySelector('.bis-error');
        var submitBtn = popup.querySelector('.bis-submit');

        if (!email || !email.includes('@')) {
          errorEl.textContent = 'Voer een geldig e-mailadres in.';
          errorEl.removeAttribute('hidden');
          return;
        }
        errorEl.setAttribute('hidden', '');
        submitBtn.disabled = true;

        fetch(wrapper.dataset.apiUrl + '/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            product_id: wrapper.dataset.productId,
            variant_id: currentVariantId,
            product_title: wrapper.dataset.productTitle,
            variant_title: currentVariantTitle,
            product_handle: wrapper.dataset.productHandle
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.success) {
            popup.querySelector('.bis-form').style.display = 'none';
            popup.querySelector('.bis-success').removeAttribute('hidden');
          } else {
            throw new Error(data.error || 'Er is iets misgegaan.');
          }
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Er is iets misgegaan. Probeer het opnieuw.';
          errorEl.removeAttribute('hidden');
          submitBtn.disabled = false;
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePopup(popup);
      });
    });
  }

  function closePopup(popup) {
    popup.setAttribute('hidden', '');
    popup.querySelector('.bis-form').style.display = '';
    popup.querySelector('.bis-success').setAttribute('hidden', '');
    popup.querySelector('.bis-email').value = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sku-variants"] && !Shopify.designMode) return;
  try {
    (function () {
  var COLOR_MAP = {
    'naturel': '#d4c5a9', 'natural': '#d4c5a9', 'natu': '#d4c5a9',
    'chocolate fondant': '#5c3d2e', 'chocolate': '#5c3d2e', 'chfo': '#5c3d2e',
    'wit': '#f5f5f0', 'white': '#f5f5f0', 'ecru': '#f0e6d3', 'off-white': '#f0ece4',
    'zwart': '#1c1c1c', 'black': '#1c1c1c',
    'grijs': '#9e9e9e', 'grey': '#9e9e9e', 'gray': '#9e9e9e',
    'lichtgrijs': '#d0d0d0', 'donkergrijs': '#5a5a5a',
    'blauw': '#4a6fa5', 'blue': '#4a6fa5', 'marine': '#1a3a5c', 'navy': '#1a3a5c',
    'lichtblauw': '#7fb3d3', 'donkerblauw': '#1a3a5c', 'kobalt': '#0047ab',
    'rood': '#c0392b', 'red': '#c0392b', 'bordeaux': '#722f37', 'wijnrood': '#722f37',
    'groen': '#4a7c59', 'green': '#4a7c59', 'olijf': '#6b7c45', 'sage': '#87a878',
    'mint': '#98d8c8', 'flessengroen': '#2d6a4f',
    'roze': '#f4a7b9', 'pink': '#f4a7b9', 'lichtroze': '#fce4ec', 'oud roze': '#c8a5b0',
    'beige': '#f5e6c8', 'zand': '#e8d5b0', 'camel': '#c19a6b', 'taupe': '#b5a08a',
    'bruin': '#8b6914', 'brown': '#8b6914', 'cognac': '#9b4500', 'terra': '#c1614f',
    'terracotta': '#c1614f', 'roest': '#b7410e',
    'geel': '#f9ca24', 'yellow': '#f9ca24', 'oker': '#c8a830', 'ochre': '#c8a830',
    'mosterd': '#c5a028', 'citroe': '#e8d000',
    'oranje': '#e67e22', 'orange': '#e67e22', 'zalm': '#fa8072', 'salmon': '#fa8072',
    'lila': '#c3a3d8', 'paars': '#9b59b6', 'purple': '#9b59b6', 'violet': '#7d3c98',
    'lavender': '#d7c4e8', 'lavendel': '#d7c4e8',
    'amandel': '#e8d5b7', 'almond': '#e8d5b7', 'ivoor': '#fffff0', 'ivory': '#fffff0',
    'brunette': '#6b3a2a', 'donker': '#4a3728'
  };

  function getSwatchColor(label) {
    var key = String(label || '').toLowerCase().trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    for (var k in COLOR_MAP) {
      if (key.indexOf(k) !== -1) return COLOR_MAP[k];
    }
    var hash = 0;
    for (var i = 0; i < key.length; i++) hash = key.charCodeAt(i) + ((hash << 5) - hash);
    return 'hsl(' + (Math.abs(hash) % 360) + ',40%,60%)';
  }

  function applyStylesTo(label) {
    var src = document.querySelector('.sku-variants__label');
    var cs = src ? window.getComputedStyle(src) : null;
    var imp = 'important';
    label.style.setProperty('font-family',    cs ? cs.fontFamily    : 'inherit',    imp);
    label.style.setProperty('font-size',      cs ? cs.fontSize      : '0.8125rem',  imp);
    label.style.setProperty('font-weight',    cs ? cs.fontWeight    : '600',        imp);
    label.style.setProperty('letter-spacing', cs ? cs.letterSpacing : '0.05em',     imp);
    label.style.setProperty('text-transform', cs ? cs.textTransform : 'uppercase',  imp);
    label.style.setProperty('margin-bottom',  cs ? cs.marginBottom  : '10px',       imp);
    label.style.setProperty('display',        'block',                              imp);
  }

  function applySizeLabel(value) {
    document.querySelectorAll('.f8pr-variant-selection ul.check.box').forEach(function(ul) {
      var label = ul.previousElementSibling;
      while (label && label.tagName !== 'LABEL') label = label.previousElementSibling;
      if (!label) return;

      applyStylesTo(label);

      var s = label.querySelector('.sku-size-selected');
      if (!s) {
        s = document.createElement('strong');
        s.className = 'sku-size-selected';
        label.insertBefore(s, label.querySelector('.text-end') || null);
      }

      var checked = ul.querySelector('input:checked');
      var selected = value !== undefined ? value : (checked ? (checked.getAttribute('title') || checked.value) : '');
      s.textContent = selected ? ': ' + selected : '';
    });
  }

  applySizeLabel();

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.f8pr-variant-selection input[type="radio"]')) return;
    var value = e.target.getAttribute('title') || e.target.value;
    [0, 100, 300].forEach(function(delay) {
      setTimeout(function() { applySizeLabel(value); }, delay);
    });
  });

  // ─── Storefront-context ───────────────────────────────────────────────────
  // Zoeken op titel werkt niet op vertaalde storefronts: de Storefront-zoek-
  // index matcht alleen de standaardtaal van de shop. `variants.sku` is geen
  // ondersteund filter. Daarom halen we de volledige gepubliceerde catalogus
  // op met @inContext en filteren we client-side op SKU-prefix.
  var LANG = String((window.Shopify && window.Shopify.locale) || 'nl').replace('-', '_').toUpperCase();
  var CTRY = String((window.Shopify && window.Shopify.country) || 'NL').toUpperCase();
  if (!/^[A-Z]{2}(_[A-Z]{2})?$/.test(LANG)) LANG = 'NL';
  if (!/^[A-Z]{2}$/.test(CTRY)) CTRY = 'NL';

  // Zelfde cachesleutel en itemvorm als lb-product-editorial.liquid, zodat één
  // fetch beide implementaties bedient binnen dezelfde sessie.
  var CACHE_KEY = 'lb_sku_catalog_v1_' + LANG + '_' + CTRY;
  var CACHE_TTL = 30 * 60 * 1000;
  var MAX_PAGES = 4;

  var QUERY = 'query($c:String) @inContext(language:' + LANG + ', country:' + CTRY + '){products(first:250,after:$c){pageInfo{hasNextPage endCursor} edges{node{handle title availableForSale variants(first:1){edges{node{sku}}} cr:metafield(namespace:"shopify",key:"color-pattern"){references(first:1){nodes{... on Metaobject{c:field(key:"color"){value} l:field(key:"label"){value}}}}}}}}}';

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || !o.p || !o.p.length) return null;
      if ((Date.now() - o.t) > CACHE_TTL) return null;
      return o.p;
    } catch (e) { return null; }
  }

  function writeCache(list) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), p: list })); } catch (e) {}
  }

  var inflight = null;

  function fetchCatalogue(token) {
    if (inflight) return inflight;
    var cached = readCache();
    if (cached) { inflight = Promise.resolve(cached); return inflight; }

    var out = [];
    function step(cursor, page) {
      return fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: QUERY, variables: { c: cursor || null } })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.errors || !d.data || !d.data.products) throw new Error('sku-variants: storefront query failed');
        var pr = d.data.products;
        (pr.edges || []).forEach(function (e) {
          var n = e && e.node;
          if (!n) return;
          var v = n.variants && n.variants.edges && n.variants.edges[0] && n.variants.edges[0].node;
          var ref = n.cr && n.cr.references && n.cr.references.nodes && n.cr.references.nodes[0];
          out.push({
            h: n.handle,
            t: n.title,
            a: n.availableForSale,
            s: (v && v.sku) || '',
            c: (ref && ref.c && ref.c.value) || '',
            l: (ref && ref.l && ref.l.value) || ''
          });
        });
        if (pr.pageInfo && pr.pageInfo.hasNextPage && pr.pageInfo.endCursor && (page + 1) < MAX_PAGES) {
          return step(pr.pageInfo.endCursor, page + 1);
        }
        return out;
      });
    }

    inflight = step(null, 0).then(function (list) { writeCache(list); return list; });
    return inflight;
  }

  document.querySelectorAll('.sku-variants[data-product-id]').forEach(function (container) {
    var skuPrefix = container.dataset.skuPrefix;
    var currentHandle = container.dataset.currentHandle;
    var token = container.dataset.storefrontToken;
    var delimiter = container.dataset.delimiter || '-';
    var productTitle = container.dataset.productTitle || '';
    var rootUrl = container.dataset.rootUrl || '/';
    var productId = container.dataset.productId;
    var hasManual = container.dataset.hasManual === '1';
    var list = container.querySelector('.sku-variants__swatches');
    var colorLabel = container.querySelector('.sku-variants__current-color');

    function productUrl(handle) {
      var root = rootUrl === '/' ? '' : String(rootUrl).replace(/\/$/, '');
      return root + '/products/' + handle;
    }

    function prefixOf(sku) {
      if (!sku) return '';
      var u = sku.toUpperCase();
      if (u.slice(0, 6) === 'LB-AMB' || u.slice(0, 3) === 'ECO') return '';
      var p = sku.split(delimiter);
      if (p.length < 2) return '';
      return p[0] + delimiter + p[1];
    }

    function labelOf(item) {
      if (item.l) return item.l;
      return String(item.t || '').split('–').pop().split(' - ').pop().trim();
    }

    function render(items) {
      if (!list || !items || items.length < 2) {
        container.style.display = 'none';
        return;
      }

      // Huidige product altijd vooraan.
      items.sort(function (a, b) {
        return (b.h === currentHandle ? 1 : 0) - (a.h === currentHandle ? 1 : 0);
      });

      list.innerHTML = '';

      items.forEach(function (item) {
        var isActive = item.h === currentHandle;
        var isSoldOut = !item.a;
        var swatchLabel = labelOf(item);
        var dotColor = item.c || getSwatchColor(swatchLabel);

        if (isActive && colorLabel) colorLabel.textContent = swatchLabel;

        var li = document.createElement('li');
        li.className = 'sku-variants__swatch'
          + (isActive ? ' sku-variants__swatch--active' : '')
          + (isSoldOut ? ' sku-variants__swatch--sold-out' : '');

        var inner = isActive ? document.createElement('span') : document.createElement('a');
        inner.className = 'sku-variants__swatch-inner';
        if (!isActive) {
          inner.href = productUrl(item.h);
          inner.setAttribute('aria-label', swatchLabel);
        }
        inner.title = swatchLabel;

        var dot = document.createElement('span');
        dot.className = 'sku-variants__dot';
        dot.style.backgroundColor = dotColor;
        dot.setAttribute('aria-hidden', 'true');
        inner.appendChild(dot);

        if (isSoldOut) {
          var line = document.createElement('span');
          line.className = 'sku-variants__sold-out-line';
          line.setAttribute('aria-hidden', 'true');
          inner.appendChild(line);
        }

        li.appendChild(inner);
        list.appendChild(li);
      });

      container.removeAttribute('hidden');
    }

    // ─── Handmatige koppeling via metafield custom.color_variants ────────────
    // Heeft voorrang. Werkt ook voor producten zonder gedeelde SKU-prefix
    // (zoals LB-AMB) zolang de winkelier handmatig kleuren heeft gekoppeld.
    var manualData = window.__skuManual && productId && window.__skuManual[productId];
    if (hasManual && manualData && manualData.length > 0) {
      render(manualData.slice());
      return;
    }

    if (!token || !skuPrefix) {
      container.style.display = 'none';
      return;
    }

    fetchCatalogue(token).then(function (all) {
      var fam = (all || []).filter(function (item) {
        return prefixOf(item.s) === skuPrefix;
      });
      render(fam);
    }).catch(function () {
      container.style.display = 'none';
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
